






































































































































































































































































































































































































import { Component } from "vue-property-decorator";
import RepairContentUpdateComponent from "./repairContentUpdateComponent.vue";
import QPropertySelect from "@/common/qPropertySelect.vue";
import propertyApi from "@/api/propertyApi";
import QPolygonFloor, { drawMode } from "@/common/qPolygonFloor.vue";
@Component({
  name: "RepairContentEdit",
  components: {
    QPropertySelect,
  },
})
export default class RepairContentEdit extends RepairContentUpdateComponent {
  async onChangeProperty() {
    this.repairContent.floor_plan_area_id = null;
    if (this.repairContent.property_id) {
      const result = await propertyApi.show(this.repairContent.property_id);
      this.repairContent.floor_plan = result.floor_plan;
      this.repairContent.property = result;

      this.$refs.floorEditor && (this.$refs.floorEditor as QPolygonFloor).loadObject(
        this.repairContent.floor_plan.svg_object,
        this.repairContent.floor_plan.areas,
        drawMode.repair
      );
    } else {
      this.$refs.floorEditor && (this.$refs.floorEditor as QPolygonFloor).loadObject(
        [],
        [],
        drawMode.repair
      );
      this.repairContent.floor_plan = null;
      this.repairContent.property = null;
    }
  }
  duplicate() {
    this.isShow = false;
    this.$nextTick().then(() => {
      this.$emit("duplicate", this.repairContent);
    })
  }
}
